import React, { useRef, useState } from "react";
import Box from "@mui/material/Box";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Stack from "@mui/material/Stack";
import ContentCopy from "@mui/icons-material/ContentCopy";
import OpenInNewOutlined from "@mui/icons-material/OpenInNewOutlined";
import { enqueueSnackbar } from "notistack";
import { useCopyToClipboard, useDebounceCallback, useResizeObserver } from "usehooks-ts";
import ReactPlayer from "react-player";
import { SectionHeading } from "../core/font-sizes";

/**
 * @param {object} props
 * @param {import("@seabrookstudios/types").Url?} [props.url]
 */
export const LatestSizzle = ({ url }) => {
  const [, copy] = useCopyToClipboard();

  const copyUrlToClipboard = () => {
    if (!url) {
      return;
    }

    copy(url);
    enqueueSnackbar("Url copied to clipboard", { variant: "info" });
  };

  const ref = useRef(null);
  const [{ width }, setSize] = useState(
    // @ts-ignore
    /** @type {Size} */ ({
      width: 0,
      height: 0,
    })
  );

  const onResize = useDebounceCallback(setSize, 200);

  useResizeObserver({
    ref,
    onResize,
  });

  if (!url) {
    return <></>;
  }

  return (
    <>
      <Stack p={2} pb={1} direction="row" display="flex" justifyContent="space-between">
        <SectionHeading>Sizzle Reel</SectionHeading>
        {url && (
          <Box>
            <ListItemIcon>
              <ListItemButton onClick={copyUrlToClipboard}>
                <ContentCopy />
              </ListItemButton>
            </ListItemIcon>
            <a href={url} target="_blank" rel="noreferrer">
              <ListItemIcon>
                <ListItemButton>
                  <OpenInNewOutlined />
                </ListItemButton>
              </ListItemIcon>
            </a>
          </Box>
        )}
      </Stack>
      {url && (
        <Box pb={2} flex={1} justifyContent="center" alignItems="center" display="flex" ref={ref}>
          <ReactPlayer light url={url} width={width - 32} height={(width - 32) * 0.5625} />
        </Box>
      )}
    </>
  );
};

/**
 * @param {object} props
 * @param {import("@seabrookstudios/types").Url?} [props.url]
 */
export const PublisherLatestSizzle = ({ url }) => {
  const [, copy] = useCopyToClipboard();

  const copyUrlToClipboard = () => {
    if (!url) {
      return;
    }

    copy(url);
    enqueueSnackbar("Url copied to clipboard", { variant: "info" });
  };

  const ref = useRef(null);
  const [{ width }, setSize] = useState(
    // @ts-ignore
    /** @type {Size} */ ({
      width: 0,
      height: 0,
    })
  );

  const onResize = useDebounceCallback(setSize, 200);

  useResizeObserver({
    ref,
    onResize,
  });

  return (
    <>
      <Stack p={2} pb={1} direction="row" display="flex" justifyContent="space-between">
        <ListItemText primary="Sizzle Reel" secondary={!url && "Not available"} />
        {url && (
          <Box>
            <ListItemIcon>
              <ListItemButton onClick={copyUrlToClipboard}>
                <ContentCopy />
              </ListItemButton>
            </ListItemIcon>
            <a href={url} target="_blank" rel="noreferrer">
              <ListItemIcon>
                <ListItemButton>
                  <OpenInNewOutlined />
                </ListItemButton>
              </ListItemIcon>
            </a>
          </Box>
        )}
      </Stack>
      {url && (
        <Box pb={2} flex={1} justifyContent="center" alignItems="center" display="flex" ref={ref}>
          <ReactPlayer light url={url} width={width - 32} height={(width - 32) * 0.5625} />
        </Box>
      )}
    </>
  );
};
